import api from "./api";

export const handleInterest = async (id: number) => {
  const { data } = await api.post(`products/interesting/`, {media: id});

  return data
}
